import { io, type Socket } from 'socket.io-client';
import { authService } from './authService';
import { SOCKET_IO_PATH, SOCKET_IO_TRANSPORTS, getSocketIoUrl } from '../config/apiConfig';

let sharedSocket: Socket | null = null;
let consumerCount = 0;

function createSharedSocket(token: string): Socket {
  return io(getSocketIoUrl(), {
    path: SOCKET_IO_PATH,
    auth: { token },
    transports: SOCKET_IO_TRANSPORTS,
    withCredentials: true,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 30000,
    randomizationFactor: 0.5,
  });
}

/** One Socket.IO connection per tab — shared by realtime invalidation, presence, and push. */
export function retainAppSocket(): (() => void) | null {
  const token = authService.getToken();
  if (!token) return null;

  if (!sharedSocket) {
    sharedSocket = createSharedSocket(token);
  }

  consumerCount += 1;

  return () => {
    consumerCount = Math.max(0, consumerCount - 1);
    if (consumerCount === 0 && sharedSocket) {
      sharedSocket.disconnect();
      sharedSocket = null;
    }
  };
}

export function getAppSocket(): Socket | null {
  return sharedSocket;
}
